module.exports = __webpack_public_path__ + "img/group_activate.32f8aa62.png";